import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * `/employees` — now `/people`.
 *
 * The register absorbed the sign-in accounts and the role assignments that used
 * to live under Administration, so what it lists is people rather than payroll
 * rows. Redirected rather than removed, because the old path is in bookmarks.
 */
export const Route = createFileRoute("/_authenticated/employees")({
  beforeLoad: () => {
    throw redirect({ to: "/people", replace: true });
  },
});
